<template>
  <el-dialog title="通知整改" :visible.sync="modalInfo.isShow" :close-on-click-modal="false" v-if="modalInfo.isShow" width="50%">
    <el-form :model="modalInfo.form" ref="ruleForm">
      <el-form-item label="整改状态" :label-width="formLabelWidth">
        <el-select v-model="modalInfo.form.status" placeholder="请选择整改状态" size="small">
          <el-option
            v-for="status in statusInfo"
            :key="status.value"
            :value="status.value"
            :label="status.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="整改说明" prop="instructions " :label-width="formLabelWidth">
        <el-input v-model="modalInfo.form.instructions" autocomplete="on" size="small"></el-input>
      </el-form-item>
      <el-form-item label="改价标准" :label-width="formLabelWidth">
        <el-input v-model="modalInfo.form.price_standard " autocomplete="off" size="small"></el-input>
      </el-form-item>
      <el-form-item label="截图" :label-width="formLabelWidth">
        <editor-bar  :isClear="isClear" @change="change"></editor-bar>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="cancel" @click="modalInfo.isShow = false">取 消</el-button>
      <el-button size="small" type="primary" class="confirm" @click="confirmClick()">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import EditorBar from "components/editerElem";
import { setTimeout } from 'timers';

export default {
	name: "newAddModel",
	components:{EditorBar },
  props: {
    modalInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
			formLabelWidth: "100px",
			// 整改状态下拉
      statusInfo: [
        { value: "0", label: "通知整改" },
        { value: "1", label: "已整改" }
      ],
			isClear: false,
      screenQuery:[],
      // 是否通知整改过
      isChange:{}
    };
  },
  created(){
    this.isChange[this.modalInfo.index] = false;
  },
  methods: {
		change(val) {
			this.screenQuery.push(val)
      this.modalInfo.form.screenshots = String(this.screenQuery);
		},
    confirmClick() {
			let query = {
				pluginid:this.modalInfo.form.itemid,
				rectificationid :this.modalInfo.form.id,
				platform:this.modalInfo.platform,
				status:this.modalInfo.form.status,
				instructions:this.modalInfo.form.instructions,
				screenshots:this.modalInfo.form.screenshots,
				priceStandard:this.modalInfo.form.price_standard,
				noticeNumber:this.modalInfo.form.notice_number
			}
      this.reqNewAdd(query);
    },
    // 新增/编辑请求
    reqNewAdd(query) {
      fetch({
        url: "/hcm/hcmNoticeRectification/save",
        method: "post",
        data: query,
        noFormat: true,
        responseType: "text"
      })
        .then(result => {
          let res = JSON.parse(result);
          if (res.status == "10000") {
            this.$message({
              message: "操作成功！",
              type: res.message
            });
            this.modalInfo.isShow = false;
            this.$emit("reqTableData");
          } else {
            this.$message.error(res.message ? res.message : "操作失败！");
          }
          setTimeout(()=>{
            this.$emit("reqTableData")
          },1000)
         
          this.isChange[this.modalInfo.index] = true
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
</style>


